import { combineReducers, createSlice } from '@reduxjs/toolkit';
import { keyById } from '@mews/fp';
import { fetchServiceAvailabilitySucceeded } from '../../serviceAvailability/reducer';
import { fetchServicePricingSucceeded } from '../../servicePricing/reducers';
import { Restrictions } from './types';

const dataInitialState: Restrictions['data'] = {};

const restrictionsDataSlice = createSlice({
    name: 'restrictionsData',
    initialState: dataInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchServiceAvailabilitySucceeded, (state, { payload: { applicableRestrictions } }) => ({
            ...state,
            ...keyById(applicableRestrictions),
        }));
        builder.addCase(fetchServicePricingSucceeded, (state, { payload: { violatedRestrictions } }) => ({
            ...state,
            ...keyById(violatedRestrictions),
        }));
    },
});

const restrictionsSlice = combineReducers({
    data: restrictionsDataSlice.reducer,
});

export { restrictionsSlice };
